const WHATSAPP_LINK = 'https://wa.me/905321737544?text=Merhaba,%20Google%20reklam%C4%B1ndan%20ula%C5%9F%C4%B1yorum.%20Ak%C3%BC%20/%20yol%20yard%C4%B1m%20veya%20yedek%20par%C3%A7a%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.';
const PHONE_LINK = 'tel:+905321737544';

const badges = [
  'Akü Takviye',
  'Yerinde Akü Değişimi',
  'Yol Yardım',
  'Orijinal Yedek Parça',
];

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[100dvh] flex items-center overflow-hidden bg-brand-dark"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20automotive%20roadside%20assistance%20mechanic%20providing%20battery%20jump%20start%20service%20to%20broken%20down%20car%20dark%20road%20night%20service%20van%20emergency%20lights%20open%20hood%20cinematic%20dark%20blue%20red%20lighting%20premium%20photorealistic%20dramatic%20atmosphere&width=1400&height=700&seq=hero1&orientation=landscape"
          alt="Otomotiv yol yardım"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/80 via-brand-dark/40 to-brand-dark/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/70 via-transparent to-brand-dark/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 pt-24 pb-12 md:pt-32 md:pb-20">
        <div className="max-w-4xl">
          {/* Badges */}
          <div className="flex flex-wrap gap-2 mb-6 md:mb-8">
            {badges.map((badge) => (
              <span
                key={badge}
                className="inline-flex items-center px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs md:text-sm font-semibold tracking-wide"
              >
                {badge}
              </span>
            ))}
          </div>

          {/* Headline */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white leading-tight tracking-tight">
            <span className="block">Akü Yol Yardım</span>
            <span className="block mt-1 md:mt-2">&amp; Orijinal Oto Yedek Parça</span>
          </h1>

          {/* Subheadline */}
          <p className="mt-5 md:mt-6 text-base md:text-lg text-brand-muted max-w-2xl leading-relaxed">
            Silivri – Tekirdağ hattında akü takviye, yerinde akü değişimi, yol yardım ve orijinal yedek parça desteği.
          </p>

          {/* CTA Buttons */}
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-3 md:gap-4 max-w-lg">
            <a
              href={PHONE_LINK}
              className="flex items-center justify-between bg-brand-accent hover:bg-brand-accentHover text-white font-bold text-base md:text-lg px-6 py-4 md:py-5 rounded-full transition-all duration-200 shadow-xl shadow-brand-accent/20 active:scale-95"
            >
              <span>Hemen Ara</span>
              <span className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/20 rounded-full ml-3">
                <i className="fas fa-phone text-sm"></i>
              </span>
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between bg-white hover:bg-gray-100 text-brand-dark font-bold text-base md:text-lg px-6 py-4 md:py-5 rounded-full transition-all duration-200 shadow-xl active:scale-95"
            >
              <span>WhatsApp'tan Hemen Yaz</span>
              <span className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-brand-dark rounded-full ml-3">
                <i className="fab fa-whatsapp text-white text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}